(function () {
  var roots = document.querySelectorAll('[data-lp-app-download]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.lpAppDownloadReady === 'true') return;
    root.dataset.lpAppDownloadReady = 'true';

    root.querySelectorAll('[data-lp-app-download-stores] [data-store]').forEach(function (link) {
      link.addEventListener('click', function () {
        var placement = link.closest('[data-lp-app-download-stores]').getAttribute('data-lp-app-download-stores') || 'intro';
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'app_download_click', {
              platform: link.getAttribute('data-store'),
              placement: placement
            });
          }
        } catch (e) {}
      });
    });
  });
})();
